import { ParticleBehaviour } from '../ParticleBehaviour';

export class ParticleCounter extends ParticleBehaviour {
	private _count: number;
	private _triggerAtFrames: number;
	private _onTrigger: Function;
	private _loop: boolean;

	public set loop(v: boolean) {
		this._loop = v;
	}

	public set onTrigger(v: Function) {
		this._onTrigger = v;
	}

	public set triggerAtFrames(v: number) {
		this._triggerAtFrames = v;
	}

	public randomiseTriggerAt(base: number, seed: number = 0): void {
		this._triggerAtFrames = Math.round(base + Math.random() * seed);
	}

	public millsecsToFrames(millsecs) {
		this._triggerAtFrames = (millsecs * 60) / 1000;
	}

	public start(): void {
		this._count = 0;
		this.active = true;
	}

	public tick(): void {
		this._count += (window as any).deltaTime;

		if (this._count >= this._triggerAtFrames) {
			this._count = 0;

			if (!this._loop) {
				this.active = false;
			}

			if (this._onTrigger) {
				this._onTrigger();
			}

			if (!this._loop) {
				this._onTrigger = null;
			}
		}
	}
}
